module.exports = __webpack_public_path__ + "5c82d96e5725e91943d075cac8520f72.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/doge-sprite.png
// module id = qpQL
// module chunks = 0